import * as React from "react";
import styled, { css } from "styled-components";
import IfInteractive from "views/components/dashboard/IfInteractive";
import RowActions from "views/components/widgets/events/EventsList/RowActions";
import useEventAttributes from "views/components/widgets/events/hooks/useEventAttributes";
const Td = styled.td(
  ({ theme }) => css`
    && {
      border-color: ${theme.colors.table.row.divider};
    }
  `
);
const EventsTableRow = ({ event, fields }) => {
  const eventAttributes = useEventAttributes();
  return /* @__PURE__ */ React.createElement("tr", { key: event.id }, fields.toArray().map((field) => {
    const value = event[field];
    const columnRenderer = (val) => {
      var _a, _b, _c;
      return (_c = (_b = (_a = eventAttributes.find(({ attribute }) => attribute === field)) == null ? void 0 : _a.displayValue) == null ? void 0 : _b.call(_a, val)) != null ? _c : val;
    };
    return /* @__PURE__ */ React.createElement(Td, { key: field }, columnRenderer(value));
  }), /* @__PURE__ */ React.createElement(IfInteractive, null, /* @__PURE__ */ React.createElement(Td, null, /* @__PURE__ */ React.createElement(
    RowActions,
    {
      eventId: event.id,
      eventDefinitionId: event.event_definition_id,
      hasReplayInfo: !!event.replay_info
    }
  ))));
};
export default EventsTableRow;
